import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DashboardComponent } from './components/dashboard/dashboard.component';
import { LogsComponent } from './components/logs/logs.component';
import { FillsComponent } from './components/fills/fills.component';
import { HomeComponent } from "./components/home/home.component";

const routes: Routes = [
    {
        path: 'dashboard/:botName',
        component: DashboardComponent
    },
    {
        path: 'logs/:botName',
        component: LogsComponent
    },
    {
        path: 'fills/:botName',
        component: FillsComponent
    },
    {
        path: '',
        component: HomeComponent
    }
];

@NgModule({
    imports: [ RouterModule.forRoot(routes) ],
    exports: [ RouterModule ]
})
export class AppRoutingModule {

}


// WEBPACK FOOTER //
// C:/Users/mybrokenwalls/workspace/mybrokenwalls/portfolio/src/app/app-routing.module.ts